export enum EmailTransactionLogStatus
{
    Error = 0,
    Sent = 1,
    Processed = 2,
    Delivered = 3,
    Failed = 4,
    Bounced = 5
}

export enum SmsTransactionStatus
{
    Sent = 1,
    Failed = 2,
    Delivered = 3,
    Received = 4
}

export enum WhatsAppMessageTransactionLogStatus
{
    Error = 0,
    Sent = 1,
    Accepted = 2,
    Delivered = 3,
    Read = 4,
    Failed = 5
}

export enum SmsTransactionType
{
    OneOnOneTransaction = 1,
    AutomationWorkflowPromo = 2,
    BulkPromo = 3,
    TriggerNotificationsTransaction = 4
}